<template>
  <div class="demo">
    <h4>round-btn</h4>
    <div>
      1、round-default单选按钮
      <SjRadio :data="data" @change="handleChange" v-model="value" vertical />
    </div>
    <div>
      2、round-small单选按钮
      <SjRadio
        :data="data"
        @change="handleChange"
        vertical
        v-model="value"
        size="small"
      />
    </div>
    <h4>button-no-border</h4>
    <div>
      1、button-mini单选按钮
      <SjRadio
        :data="data"
        v-model="value"
        :allowNull="true"
        type="button"
        size="mini"
        vertical
      />
    </div>
    <div>
      2、button-small单选按钮
      <SjRadio
        :data="data"
        v-model="value"
        :allowNull="true"
        type="button"
        size="small"
      />
    </div>
    <div>
      3、button-default单选按钮
      <SjRadio :data="data" v-model="value" :allowNull="true" type="button" />
    </div>
    <div>
      4、button-middle单选按钮
      <SjRadio
        :data="data"
        v-model="value"
        :allowNull="true"
        type="button"
        size="middle"
      />
    </div>
    <div>
      5、button-large单选按钮
      <SjRadio
        :data="data"
        v-model="value"
        :allowNull="true"
        type="button"
        size="large"
      />
    </div>
    <h4>button-border</h4>
    <div>
      1 、button-mini单选按钮
      <SjRadio
        :data="data"
        v-model="value"
        :allowNull="true"
        type="button"
        size="mini"
        border
      />
    </div>
    <div>
      2、button-small单选按钮
      <SjRadio
        :data="data"
        v-model="value"
        :allowNull="true"
        type="button"
        size="small"
        border
      />
    </div>
    <div>
      3、button-default单选按钮
      <SjRadio
        :data="data"
        v-model="value"
        :allowNull="true"
        type="button"
        size="default"
        border
      />
    </div>
    <div>
      4、button-middle单选按钮
      <SjRadio
        :data="data"
        v-model="value"
        :allowNull="true"
        type="button"
        size="middle"
        border
      />
    </div>
    <div>
      5、button-large单选按钮
      <SjRadio
        :data="data"
        v-model="value"
        :allowNull="true"
        type="button"
        size="large"
        border
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: "C",
      data: [
        {
          name: "柱状图",
          value: "A"
        },
        {
          name: "柱状图",
          value: "F"
        },
        {
          name: "柱状图",
          value: "G"
        },
        {
          name: "折线图",
          value: "B"
        },
        {
          name: "饼状图",
          value: "C"
        },
        {
          name: "表格",
          value: "D",
          disabled: true
        },
        {
          name: "散点图",
          value: "E"
        }
      ]
    };
  },
  methods: {
    handleChange(value) {
      alert(`changed: ${value}`);
    }
  }
};
</script>

<style scoped lang="less">
.demo {
  display: flex;
  flex-direction: column;
  padding: 30px;
  > * {
    margin-bottom: 10px;
  }
}
</style>
